import { orderStatus } from 'utils/orderStatus';

export default {
    [orderStatus[0]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'PA-All Pending': [
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
        {
            name: 'CSA Approval',
            status: 'hourglass',
        },
    ],
    'PA-Manager Approved': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'hourglass',
        },
    ],
    'PA-CSA Approved': [
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
    ],
    'PA-Only Manager': [
        {
            name: 'Manager Approval',
            status: 'hourglass',
        },
    ],
    [orderStatus[1]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: orderStatus[1]?.name,
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    [orderStatus[2]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Cancelled',
            status: 'clear',
        },
    ],
    [orderStatus[3]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'clear',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'CSA Rejected': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'clear',
        },
    ],
    'Manager Rejected': [
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'clear',
        },
    ],
    'Manager Rejected-CSA Pending': [
        {
            name: 'Manager Approval',
            status: 'clear',
        },
        {
            name: 'CSA Approval',
            status: 'wait',
        },
    ],
    'CSA Rejected-Manager Pending': [
        {
            name: 'CSA Approval',
            status: 'clear',
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
    ],
    [orderStatus[4]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: 'Completed',
            status: 'done',
        },
    ],
    [orderStatus[5]?.name]: [
        {
            name: 'Requested',
            status: orderStatus[0]?.name,
        },
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
        {
            name: 'Provisioning',
            status: 'wait',
        },
        {
            name: orderStatus[4]?.name,
            status: 'wait',
        },
    ],
    'Manager Returned': [
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
        {
            name: 'CSA Approval',
            status: 'wait',
        },
    ],
    'CSA Returned': [
        {
            name: 'CSA Approval',
            status: 'priority-high',
        },
        {
            name: 'Manager Approval',
            status: 'wait',
        },
    ],
    'Manager Approved CSA Returned': [
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'priority-high',
        },
    ],
    'Manager Returned CSA Approved': [
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
    ],
    'Manager Returned CSA Returned': [
        {
            name: 'Manager Approval',
            status: 'priority-high',
        },
        {
            name: 'CSA Approval',
            status: 'priority-high',
        },
    ],
    [orderStatus[6]?.name]: [
        {
            name: 'Requested',
            status: 'done',
        },
        {
            name: 'Manager Approval',
            status: 'done',
        },
        {
            name: 'CSA Approval',
            status: 'done',
        },
        {
            name: 'Provisioning',
            status: 'done',
        },
        {
            name: orderStatus[4]?.name,
            status: 'hourglass',
        },
    ],
};
